/*
  Loopback setup:

      The standard jsdata http adapters expects valid request calls to be within 200 -> 299.
      Loopback returns 404 (Not Found) vs 204 no content.
           404 causes the http adapter to fail..

           to remedy this in loopback, change the return code for not found.
           loopback\lib\persisted-model.js
               Find and replace 404 with 204

 */

import {utils, Mapper} from "js-data";
import * as _ from 'lodash'

export function transform_parameters(params: any): any {
  // Transform JSData params into Loopback Parameters
  //
  // JSData Parameters l
  // http://www.js-data.io/v3.0/docs/query-syntax
  //
  // looks like
  // {"where":{"WB_CUST_ID_SOURCE":{"==":147}}}
  //
  // and transforms it into
  //  https://loopback.io/doc/en/lb3/Querying-data.html
  //
  // looks like ...
  //?filter[where][name]=John&filter[limit]=3
  //
  // or
  //
  //  looks like  (We chose this one, as it more closely matches the jsData query format)
  // https://loopback.io/doc/en/lb3/Where-filter.html#node-api
  //?filter={ Stringified-JSON }
  //
  //  ?filter={"where":{"id":1234}}
  //
  var jsDataToLoopback: any = {
    "==": "=",
    "in": "inq",
    "notIn": "nin",
    "contains": "like",
    "notContains": "nlike",
    "orderBy": "order",
    ">=": "gte",
    ">": "gt",
    "<=": "lte",
    "<": "lt",
    "!=": "neq",
    "<>": "neq"
  }

  var dctEmptyObjectSubstitute: any = {
    "in": [],
    "notIn": []
  }

  function refit_keys(o: any): any {
    var key, destKey, ix, value;

    var build: any = {};
    for (key in o) {
      // Get the destination key
      destKey = jsDataToLoopback[key] || key;

      // Get the value
      value = o[key];

      // If this is an object, recurse
      if (typeof value === "object") {
        if (key in dctEmptyObjectSubstitute) {
          if (Object.keys(value).length === 0) {
            value = dctEmptyObjectSubstitute[key];
          } else {
            value = refit_keys(value);
          }
        }
        else
          value = refit_keys(value);
      }

      // Set it on the result using the destination key
      build[destKey] = value;
    }
    return build;
  }

  if ('filter' in params) {
    // This happens on cascade
    delete params.filter
  }
  var new_params = refit_keys(params);

  // sometimes the query from jsData looks like
  //  {Filter_Field: value} other times it is correct
  //  correct:  { where: {filter_field: operator}..}
  //

  if ('where' in new_params) {
    if ('order' in new_params) {
      new_params.order = transform_order_parameters(new_params.order)
    }
    return (new_params);
  } else {
    let orderclause = null;
    if ('order' in new_params) {
      orderclause = new_params.order;
      delete new_params.order;
      return ({where: new_params, order: transform_order_parameters(orderclause)})
    }
    else {
      return ({where: new_params})
    }
  }
}

function transform_order_parameters(order_params: any): any {

  if (_.isArray(order_params)) {
    let newOrderParams: any[] = []
    _.forEach(order_params, (anOrderItem) => {
      if (_.isArray(anOrderItem)) {
        newOrderParams.push(anOrderItem.join(' ')) // change from js-data Order by format... to loopback
      } else {
        newOrderParams.push(anOrderItem)
      }
    })
    return newOrderParams
  }

  if (_.isObjectLike(order_params)) {
    let newOrderParams: any = {}
    _.forEach(order_params, (value, key) => {
      if (_.isString(value)) {
        newOrderParams[key] = value
      } else if(_.isObjectLike(value)) {
        newOrderParams[key] = _.toArray(value).join(' ')
      }
    })

    return _.toArray(newOrderParams)
  }

  return order_params
}


/**
 * @name HttpAdapter#getPath
 * @method
 * @param {string} method The method being executed.
 * @param {Object} mapper The Mapper.
 * @param {(string|number)?} id The primary key, if any.
 * @param {Object} opts Configuration options.
 */
export function LoopbackgetPath(method: string, mapper: any, id: number | string, opts: any) {
  opts || (opts = {})
  const args = [
    opts.basePath === undefined ? (mapper.basePath === undefined ? this.basePath : mapper.basePath) : opts.basePath,
    this.getEndpoint(mapper, (utils.isString(id) || utils.isNumber(id) || method === 'create') ? id : null, opts)
  ]
  if (method === 'find' || method === 'destroy') {
    args.push(id)
  }
  if (method === 'update') {
    //args.push('replace')
  }

  return makePath.apply(utils, args)
}

function isValidString(value: any) {
  return (value != null && value !== '')
}

function join(items: any, separator: any) {
  separator || (separator = '')
  return items.filter(isValidString).join(separator)
}

function makePath(...args: any[]) {
  let result = join(args, '/')
  return result.replace(/([^:\/]|^)\/{2,}/g, '$1/')
}
